import React from "react";

// Admin Imports
import MainDashboard from "views/admin/default";
import Licenses from "views/admin/licenses";
import Users from "views/admin/users";
import VergiTakvimi from "views/admin/vergi-takvimi";
import Duyurular from "views/admin/duyurular";
import Content from "views/admin/content";
import Links from "views/admin/links";
import Settings from "views/admin/settings";
import Destek from "views/admin/destek";

// Auth Imports
import SignIn from "views/auth/SignIn";

// Icon Imports
import {
  MdHome,
  MdKey,
  MdPeople,
  MdEvent,
  MdNotifications,
  MdArticle,
  MdLink,
  MdSettings,
  MdLock,
  MdSupportAgent,
} from "react-icons/md";

const routes = [
  {
    name: "Dashboard",
    layout: "/admin",
    path: "default",
    icon: <MdHome className="h-6 w-6" />,
    component: <MainDashboard />,
  },
  {
    name: "Lisanslar",
    layout: "/admin",
    path: "licenses",
    icon: <MdKey className="h-6 w-6" />,
    component: <Licenses />,
  },
  {
    name: "Kullanicilar",
    layout: "/admin",
    path: "users",
    icon: <MdPeople className="h-6 w-6" />,
    component: <Users />,
  },
  {
    name: "Vergi Takvimi",
    layout: "/admin",
    path: "vergi-takvimi",
    icon: <MdEvent className="h-6 w-6" />,
    component: <VergiTakvimi />,
  },
  {
    name: "Duyurular",
    layout: "/admin",
    path: "duyurular",
    icon: <MdNotifications className="h-6 w-6" />,
    component: <Duyurular />,
  },
  {
    name: "Faydali Linkler",
    layout: "/admin",
    path: "links",
    icon: <MdLink className="h-6 w-6" />,
    component: <Links />,
  },
  {
    name: "Icerik Yonetimi",
    layout: "/admin",
    path: "content",
    icon: <MdArticle className="h-6 w-6" />,
    component: <Content />,
  },
  {
    name: "Destek",
    layout: "/admin",
    path: "destek",
    icon: <MdSupportAgent className="h-6 w-6" />,
    component: <Destek />,
  },
  {
    name: "Ayarlar",
    layout: "/admin",
    path: "settings",
    icon: <MdSettings className="h-6 w-6" />,
    component: <Settings />,
  },
  {
    name: "Giris",
    layout: "/auth",
    path: "sign-in",
    icon: <MdLock className="h-6 w-6" />,
    component: <SignIn />,
  },
];
export default routes;
